export const projects = [
  {
    title: "React projects",
    subtitle: "MERN Stack",
    description: "Github page for source code.",
    image:
      "https://images.pexels.com/photos/11035471/pexels-photo-11035471.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    link: "https://github.com/Susheel4115/React-assignments",
  },
  {
    title: "React Quiz app",
    subtitle: "React typescript",
    description: "This is a quiz app",
    image: "https://images.pexels.com/photos/5063562/pexels-photo-5063562.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    link: "https://relaxed-clarke-04b2a5.netlify.app/",
  },
  {
    title: "Html and css portfolio",
    subtitle: "Built with html,css and vanilla js",
    description: "This is my other portfolio.",
    image: "https://images.pexels.com/photos/6535346/pexels-photo-6535346.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    link: "https://susheel4115.github.io/testupload/index.html",
  },
  {
    title: "Todo App",
    subtitle: "With plain javascript.",
    description: "Todo app with plain javascript.",
    image:
      "https://images.pexels.com/photos/3243/pen-calendar-to-do-checklist.jpg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    link: "https://friendly-shaw-29438b.netlify.app/",
  },
];

export const skills = [
  "Python",
  "Html",
  "Css",
  "Javascript",
  "React",
  "Node",
  "Typescript",
  "Tailwind",
  "Data structures & algo's",
  "Material UI",
  "C++ v20",
  "Vue 3"
];

export const testimonials = [
  {
    quote: "Leetcode 🦹‍♂️",
    image:
      "https://leetcode.com/static/images/LeetCode_logo_rvs.png",
    name: "Problems Solved:",
    company: "200+",
    url : "https://leetcode.com/Susheel4115/",
  },
  {
    quote: "GeeksForGeeks🐱‍💻",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/43/GeeksforGeeks.svg/2560px-GeeksforGeeks.svg.png",
    name: "Problems solved:",
    company: "100+",
    url : "https://auth.geeksforgeeks.org/user/gammagoblin/practice",
  },
];
